import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router, NavigationEnd } from '@angular/router';
import { SplitPaneService } from './services/split-pane.service';
import { ApiService } from './services/api.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent implements OnInit {

  selectedIndex = 0;

  public appPages = [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: 'grid-outline',
      showIf: ['master', 'user']
    },
    {
      title: 'Users',
      url: '/users',
      icon: 'person-circle-outline',
      showIf: ['master']
    },
    {
      title: 'User',
      url: '/user',
      icon: 'person-circle-outline',
      showIf: ['user']
    },
    {
      title: 'Polls',
      url: '/polls',
      icon: 'podium-outline',
      showIf: ['master', 'user']
    },
    {
      title: 'Posts',
      url: '/posts',
      icon: 'chatbubble-ellipses-outline',
      showIf: ['master', 'user']
    },
    {
      title: 'Languages',
      url: '/languages',
      icon: 'language-outline',
      showIf: ['master', 'user']
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    public splitPane: SplitPaneService,
    public apiService: ApiService) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd)
        for (let a = 0; a < this.appPages.length; a++)
          if (this.appPages[a].url === event.urlAfterRedirects || event.urlAfterRedirects.startsWith(this.appPages[a].url + "/"))
            this.selectedIndex = a;
    });
  }

  onIndexChanged(index: number) {
    console.log("fin qui...");
    this.selectedIndex = index;
  }

  goToLogin() {
    this.router.navigate['/login'];
  }
}
